// extracted by mini-css-extract-plugin
export default {"root":"K4Di6","small":"Fs96n","normal":"_2Spgi"};